import { getCurrentLocaleCode } from "@mongez/localization";

export const currentLocaleCode = () => getCurrentLocaleCode();
export const isLTR = () => currentLocaleCode() === "en";
export const isRTL = () => currentLocaleCode() === "ar";
export const currentDirection = () => (isLTR() ? "ltr" : "rtl");
